import { NavigationMockApi } from 'app/api/common/navigation/api';

export const mockApiServices = [
    NavigationMockApi,
];
